export default __webpack_public_path__ + "static/media/ui.25ac2702.png";